export const projects = [
  {
    title: "Node.ts-api-postgresql-crud",
    subtitle: "Express.js, Sequelize, pg, zod, Nodemon, TypeScript  ",
    description:
      "This was a practise api project made with node typescript and is connected to a postgresql db",
    image: "https://assets.northflank.com/Group_321_160b91d960.png",
    link: "https://github.com/RasmusRossetti/Node.ts-api-postgresql-crud"
  },
  {
    title: "Timelock: Your Timebooking App",
    subtitle: "React, Firebase, Tailwind",
    description:
      "Timelock is an app designed to help you make appointments on specific dates and times during the year. Created specifically for the use of an association to schedule appointments.",
    image:
      "https://www.elegantthemes.com/blog/wp-content/uploads/2019/08/Appointment-Hour-Booking-Plugin-Overview-Featured-Image.jpg",
    link: "https://github.com/RasmusRossetti/TimeLockBeta"
  },
  {
    title: "E-commerce project",
    subtitle: "Next.js, Sanity CMS, Tailwind",
    description:
      "This was a E-commerce project made for Umain. The application runs on next js and sanity CMS.",
    image:
      "https://cdn.sanity.io/images/81pocpw8/production/8b36e4a78aea2fddf80250f845455c64fa2ad973-2400x1500.jpg?rect=0,121,2400,1256&w=1200&h=628&fit=max&auto=format",
    link: "https://github.com/RasmusRossetti/Umain-task"
  },
  {
    title: "Authentication app",
    subtitle: "React, Redux, Firebase",
    description:
      "Authentication app made using redux and running with firebase google Auth.",
    image: "https://miro.medium.com/max/1200/1*UlxxmP6ESTWYGzHFg7wDDQ.png",
    link: "https://github.com/RasmusRossetti/auth-redux-firebase-app"
  },
  {
    title: "Weather app",
    subtitle: "React ",
    description:
      "Weather app made with react fetching API information and also lets user type in favorite country or city to display weather.",
    image:
      "https://www.timeanddate.com/scripts/weather_og.php?h1=Weather&h2=Local%20Weather%20Around%20the%20World",
    link: "https://compassionate-leakey-1289d3.netlify.app/"
  },
  {
    title: "Account app",
    subtitle: "Html, Css , Js",
    description:
      "An account app made with basic html css and javascript, created to simulate an single page application without a framework.",
    image:
      "https://www.jotform.com/blog/wp-content/uploads/2019/04/form-design-ultimate-guide-FFEBE9.png",
    link: "https://github.com/RasmusRossetti/Add-account-app"
  },
  {
    title: "Firebase Todo-App",
    subtitle: "React, Firebase",
    description:
      "An application made with create-react-app and firebase hosting a realtime database communicating back and forth.",
    image: "https://dz2cdn1.dzone.com/storage/temp/13698471-blogfirebase.png",
    link: "https://github.com/RasmusRossetti/Firebase-todo-app"
  },
  {
    title: "Full stack App",
    subtitle: "React, Node.js",
    description:
      "This project is a fullstack application with built backend server to handle requests such as the CRUD operation. The frontend is built with react.",
    image:
      "https://res.cloudinary.com/practicaldev/image/fetch/s--Qhu3PUis--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/y63ie8bmktwik5w3mhlg.png",
    link: "https://github.com/RasmusRossetti/full-stack"
  },
  {
    title: "Headless CMS app",
    subtitle: "React, Strapi",
    description:
      "project was made to practise CRUD operations and communication with front and backend. Backend is run by a headless CMS (STRAPI).",
    image: "https://miro.medium.com/max/1400/1*y5d-je-3BZUrgg0Hxf7CyA.png",
    link: "https://github.com/RasmusRossetti/CRUD-App"
  }
]

export const skills = [
  {
    skill: "Typescript"
  },
  {
    skill: "C#"
  },
  {
    skill: "ASP.NET"
  },
  {
    skill: "Jest"
  },
  {
    skill: "X unit"
  },
  {
    skill: "AWS"
  },
  {
    skill: "React"
  },
  {
    skill: "Next.js"
  },
  {
    skill: "Node.js"
  },
  {
    skill: "SASS"
  },
  {
    skill: "Tailwind"
  },
  {
    skill: "Css"
  },
  {
    skill: "HTML"
  },
  {
    skill: "Javascript"
  },
  {
    skill: "Redux"
  },
  {
    skill: "Redux saga"
  },
  {
    skill: "Express.js"
  },
  {
    skill: "Microservices"
  },
  {
    skill: "Confluence"
  },
  {
    skill: "Jira"
  }
]

export const testimonial = [
  {
    quote:
      "Rasmus is a talented dev with a bright future. He got acquainted with the project very well and was one of the contributors from the early stages of joining Qliro. He is also a nice and friendly guy and takes advice very professionally. You could benefit from his talent growing in your company and you have a friendly guy joining your team.",
    image: "https://picsum.photos/200",
    name: "Michel",
    company: "Team Lead at Qliro"
  },
  {
    quote:
      "At Qliro, Rasmus has proven to be a real team player. He rapidly got acquainted with agile principles as much as with JavaScript and .NET development, participating in the entire software development life cycle, from story/design, through development, production and beyond.",
    image: "https://picsum.photos/200",
    name: "Alireza",
    company: "Software Engineer at Qliro"
  },
  {
    quote:
      "Rasmus is one of young but potential developer I have ever got to work with. He doesn't depend on one technology frame as he has showed his skills on different technologies such as React , css, .Net technologies , etc.... One of his main strength is his effective and clear communication. And he is proved to be a fast learner. I had the privilege of working with him during his internship at Qliro. He is really good team player and very humble person.Hence there is no hesitation for me to recommend Rasmus anywhere as he would be an ideal fit for any organization",
    image: "https://picsum.photos/200",
    name: "Channa Kariyawasam",
    company: "Software Engineer at Qliro"
  },
  {
    quote:
      "I had the opportunity to work alongside Rasmus when he joined Qliro as an intern and it was a pleasure to work with him. He has a friendly personality, is highly motivated to learn, and isn't hesitant to explore new areas outside his comfort zone.Rasmus proved to be a quick learner who was able to contribute to the team shortly after joining.During his internship, Rasmus had the opportunity to familiarise himself with the various phases of SDLC. He actively participated in planning sessions, conducted code reviews, and developed and released new features to production.In my opinion, Rasmus would be an excellent fit for any development position, and I highly recommend him.",
    image: "https://picsum.photos/200",
    name: "Stelios Ladopoulos",
    company: "Lead Software Engineer at Qliro"
  },
  {
    quote:
      "Ive worked with rasmus for a couple of years he is an amazing collegue and has a great spirit and a really positive personality. He loves to work hard and has a great work pace to complete task so the deadlines he gets is never a problem.",
    image: "https://picsum.photos/200",
    name: "Larsson",
    company: "Sturehof"
  },
  {
    quote:
      "Ive spent many years with rasmus he is a great sport and he truly has a understanding of customer service and getting work done in time. He is a very confident person and gets very well with the team, hes contribution was very much appreciated.",
    image: "https://picsum.photos/200",
    name: "Robin",
    company: "Svenska Brasserier"
  },
  {
    quote:
      "During our time as colleagues Rasmus has proved many talents such as competence, experience and great personality. First time we met i was immediately impressed by rasmus, during that time he easily surpassed his colleagues when it comes to knowledge and experience. He is also a hard worker and no problem getting work done. ",
    image: "https://picsum.photos/200",
    name: "Simon",
    company: "Stockholms Matmarknad"
  },
  {
    quote:
      "Rasmus has during his time at Svenska Brasserier been a motivated and a loyal coworker and is really appreciated among colleagues. He is also highly respected  thanks to his will to help his coworkers. He has shown a high communication skill, creativity, wellorganized and has a strong responsibility. ",
    image: "https://picsum.photos/200",
    name: "Johannes",
    company: "Svenska Brasserier"
  }
]
